import { getPublicReport } from "@/api/endpoints/reports";
import { useQuery } from "@tanstack/react-query";

export const usePublicReport = (url: string) => {
  return useQuery({
    queryKey: ["public-report", url],
    queryFn: () => {
      return getPublicReport(url);
    },
  });
};
